<script setup lang="ts">
import type { ReferenceLandingPageItem } from '~/types/api/ReferenceDetail'

const props = defineProps<{
  landingPageItem: ReferenceLandingPageItem
}>()
const tag = props.landingPageItem.module_data.tag ?? 'h2'
</script>

<template>
  <h2 :class="`c-title ${tag}`" v-html="landingPageItem.name" />
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-title {
  margin-bottom: 80px;
  text-align: center;
  line-height: 1;

  @include breakpoint-down('lg') {
    margin-bottom: 60px;
  }

  @include breakpoint-down('xs') {
    margin-bottom: 40px;
  }
}
</style>
